import { createFileRoute, redirect } from '@tanstack/react-router'
import { APP_ROUTES } from '@shared/app-routes'

export const Route = createFileRoute('/dashboard/plans')({
  beforeLoad: () => {
    throw redirect({ to: APP_ROUTES.dashboard.home })
  },
  component: DashboardPlansRedirect,
})

function DashboardPlansRedirect() {
  return null
}
